import { CHUNK_SIZE } from './shared'

export function chunkIdToCoords(id) {
  const cx = parseInt(id.split('_')[0])
  const cy = parseInt(id.split('_')[1])
  return [cx, cy]
}

export function posToChunkId(x, y) {
  let cx = Math.floor(x + 0.5)
  let cy = Math.floor(y + 0.5)
  cx = Math.floor(cx / CHUNK_SIZE)
  cy = Math.floor(cy / CHUNK_SIZE)
  return `${cx}_${cy}`
}

export function num(min, max, dp = 0) {
  const value = Math.random() * (max - min) + min
  return parseFloat(value.toFixed(dp))
}
